export default __webpack_public_path__ + "static/media/qrcode.3ffaf5f6.png";